import React from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import getOrdine from "../../services/getOrdine";
import { Box, FormControlLabel, styled, TextField } from "@material-ui/core";
import CustomExpireTecnico from "../../components/CustomExpireTecnico";
import LoadingButton from "@mui/lab/LoadingButton";
import _default from "../../themes/default";
import editOrdineTecnico from "../../services/editOrdineTecnico";
import Switch from '@mui/material/Switch';
import { Stack } from "@mui/system";
import getCliente from "../../services/getCliente";
import addReminder from "../../services/addReminder";

const cookies = new Cookies();
let username = cookies.get('username', { path: '/' });
let token = cookies.get('token', { path: '/' });

const Android12Switch = styled(Switch)(({ theme }) => ({
    margin: 8,
    padding: 8,
    '& .MuiSwitch-track': {
        borderRadius: 22 / 2,
        '&:before, &:after': {
            content: '""',
            position: 'absolute',
            top: '50%',
            transform: 'translateY(-50%)',
            width: 16,
            height: 16,
        },
        '&:before': {
            backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
                theme.palette.getContrastText(theme.palette.primary.main),
            )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
            left: 12,
        },
        '&:after': {
            backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
                theme.palette.getContrastText(theme.palette.primary.main),
            )}" d="M19,13H5V11H19V13Z" /></svg>')`,
            right: 12,
        },
    },
    '& .MuiSwitch-thumb': {
        boxShadow: 'none',
        width: 16,
        height: 16,
        margin: 2,
    },
})
);

export default class EditOrdineTecnico extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            rif: '',
            sopralluoghi: [],
            prodotti: [],
            loading: false,
            cliente: '',
            descrizione: '',
            concluso: false,
        };

    }

    async componentDidMount() {
        this.setState({ loading: true })
        username = cookies.get('username', { path: '/' });
        token = cookies.get('token', { path: '/' });
        let current = cookies.get('ordine', { path: '/' });

        let ordine = await getOrdine(username, token, current);
        let cliente = await getCliente(username, token, ordine.id_cliente);

        this.setState({
            loading: false,
            cliente: cliente,
            descrizione: ordine.descrizione,
            sopralluoghi: JSON.parse(ordine.sopralluoghi) || [],
            prodotti: JSON.parse(ordine.prodotti) || [],
            concluso: parseInt(ordine.concluso_tecnico) === 1 ? true : false,
            rif: ordine.rif
        });
    }

    render() {
        return (
            <>
                <PageTitle title={`Modifica Ordine ${this.state.rif}`} />
                <Box>
                    <Stack direction="row" spacing={2} style={{ marginTop: 20 }}>
                        <TextField
                            style={{ width: 300 }}
                            value={this.state.cliente.ragione_sociale}
                            label="Cliente"
                            onChange={(e) => {
                                this.setState({ cliente: e.target.value });
                            }}
                            inputProps={{ readOnly: true }}
                            variant="outlined"
                            InputLabelProps={{ shrink: this.state.cliente.ragione_sociale }}
                        />
                        <TextField
                            style={{ width: 600, marginLeft: 20 }}
                            label="Descrizione"
                            multiline
                            value={this.state.descrizione}
                            onChange={(e) => {
                                this.setState({ descrizione: e.target.value });
                            }}
                            inputProps={{ readOnly: true }}
                            variant="outlined"
                            InputLabelProps={{ shrink: this.state.desc }}
                        />

                    </Stack>
                    <Stack direction="column" spacing={2} style={{ marginTop: 20 }}>

                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'left', flexDirection: 'row', marginTop: 20 }}>
                            <h3 style={{ marginLeft: 5, marginTop: 15 }}>Sopralluoghi</h3>
                            <img src={require('../../images/add.png')} alt="" style={{ marginLeft: 10, cursor: 'pointer', width: 20, height: 20 }}
                                onClick={() => {
                                    var sop = this.state.sopralluoghi;
                                    sop.push({});
                                    this.setState({ sopralluoghi: sop });
                                }}
                            />
                        </div>

                        {this.state.sopralluoghi.length > 0 && this.state.sopralluoghi.map((fat, i) =>
                            <CustomExpireTecnico key={i} value={fat}

                                onDayUpdate={(newDay) => {
                                    var sopralluoghi = this.state.sopralluoghi;
                                    sopralluoghi[i].day = newDay;
                                    this.setState({ sopralluoghi });
                                }}

                                onDescUpdate={(newDesc) => {
                                    var sopralluoghi = this.state.sopralluoghi;
                                    sopralluoghi[i].descrizione = newDesc;
                                    this.setState({ sopralluoghi });
                                }}

                                onDelete={() => {
                                    var fat = this.state.sopralluoghi.filter((f, index) => index !== i);
                                    this.setState({ sopralluoghi: [] });
                                    setTimeout(() => {
                                        this.setState({ sopralluoghi: fat });
                                    }, 10);
                                }}
                            />
                        )}

                        {this.state.prodotti.length > 0 && <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'left', flexDirection: 'row', marginTop: 20 }}>
                            <h3 style={{ marginLeft: 5, marginTop: 15 }}>Lista Prodotti</h3>
                        </div>}

                        {this.state.prodotti.length > 0 && this.state.prodotti.map(prodotto =>

                            <Stack direction='row' spacing={2} sx={{ flex: 1 }}>
                                <TextField
                                    style={{ width: 600 }}
                                    value={prodotto.label}
                                    label="Nome"
                                    variant="outlined"
                                    InputLabelProps={{ shrink: true }}
                                    InputProps={{ readOnly: true }}
                                />
                                <TextField
                                    style={{ width: 300 }}
                                    value={prodotto.quantita}
                                    label="Quantità"
                                    variant="outlined"
                                    InputLabelProps={{ shrink: true }}
                                    InputProps={{ readOnly: true }}
                                />
                            </Stack>
                        )}

                        <FormControlLabel
                            control={<Android12Switch checked={this.state.concluso} onChange={() => {
                                this.setState({ concluso: !this.state.concluso })
                            }} />}
                            label="Concluso"
                        />

                        <LoadingButton sx={{ minHeight: 40, width: 300 }} style={{ backgroundColor: _default.palette.primary.main }} variant='contained' loading={this.state.loading} onClick={() => this.save()}>salva</LoadingButton>

                    </Stack>
                </Box>
            </>
        );
    }

    async save() {

        this.setState({ isLoading: true });
        const cookies = new Cookies();
        const username = cookies.get('username', { path: '/' });
        const token = cookies.get('token', { path: '/' });

        let sop = this.state.sopralluoghi.filter(s => !s.descrizione || !s.day);
        if (sop.length > 0) {
            alert('Ci sono alcuni campi incompleti nei sopralluoghi.');
            return;
        }

        let ordine = {
            id: cookies.get('ordine', { path: '/' }),
            sopralluoghi: this.state.sopralluoghi,
            concluso: this.state.concluso,
        };

        let res = await editOrdineTecnico(username, token, ordine);
        if (res.result === 'ok') {
            if (this.state.concluso) {
                await addReminder(username, token, 'Concluso sopralluogo tecnico ' + this.state.rif, 'amministrazione', 'ordine', ordine.id)
            } else {
                addReminder(username, token, 'Modifica sopralluoghi ' + this.state.rif, 'amministrazione', 'ordine', ordine.id)
            }
            window.location.href = '/#/tecnico/ordini';
            return;
        }

        this.setState({ isLoading: false });
        alert('Si è verificato un errore durante la creazione del cliente. Per favore, riprova.');
    }
}

